import { render, staticRenderFns } from "./orgInfor.vue?vue&type=template&id=8a143ae0&scoped=true"
import script from "./orgInfor.vue?vue&type=script&lang=js"
export * from "./orgInfor.vue?vue&type=script&lang=js"
import style0 from "./orgInfor.vue?vue&type=style&index=0&id=8a143ae0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a143ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a143ae0')) {
      api.createRecord('8a143ae0', component.options)
    } else {
      api.reload('8a143ae0', component.options)
    }
    module.hot.accept("./orgInfor.vue?vue&type=template&id=8a143ae0&scoped=true", function () {
      api.rerender('8a143ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/orgInfor.vue"
export default component.exports